import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Presentational service-type card, matching the look of ziti-console-lib's (unexported)
 * `lib-card` component used on the `/services/select` chooser.
 */
@Component({
    selector: 'netfoundry-ui-service-card',
    templateUrl: './service-card.component.html',
    styleUrls: ['./service-card.component.scss'],
    standalone: false,
})
export class ServiceCardComponent {
    @Input() imageUrl = '';
    @Input() title = '';
    @Input() content = '';
    @Input() buttonText = '';
    @Input() id = '';
    @Output() cardClicked = new EventEmitter<void>();

    onClick(event: Event): void {
        event.preventDefault();
        this.cardClicked.emit();
    }
}
